import React, { useEffect, useState, useRef, Component } from 'react';
import { MessageSquare } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
// Map routes to their accent colors
function getAccentColor(pathname: string): string {
  if (pathname.includes('subcontractors') || pathname.includes('contractors')) {
    return '#14b88a';
  }
  // Default brand accent for all other pages
  return '#1DB954';
}
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  const scrollTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const lastScrollY = useRef(0);
  const location = useLocation();
  const accentColor = getAccentColor(location.pathname);
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      const isScrollingDown = currentY > lastScrollY.current && currentY > 100;
      lastScrollY.current = currentY;
      if (isScrollingDown) {
        setVisible(true);
      }
      // Clear existing timeout
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      // Hide after 1 second of no scrolling
      scrollTimeoutRef.current = setTimeout(() => {
        setVisible(false);
      }, 1000);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);
  return <AnimatePresence data-id="element-1209">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 30
    }} className="fixed bottom-4 left-4 z-40 md:hidden" data-id="element-1210">
          <a href={`sms:2066193742?body=${encodeURIComponent("Hi, I'm on your website and I have a question")}`} className="flex items-center justify-center text-white shadow-lg opacity-80" style={{
        width: 55,
        height: 36,
        borderRadius: 18,
        backgroundColor: accentColor
      }} aria-label="Chat Now" data-id="element-1211">
            <MessageSquare className="w-5 h-5" data-id="element-1212" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}